<template>
  <ion-page>
    <!-- <ion-header>
        <ion-toolbar>
          <ion-buttons slot="start" @click="goPrev()">
            <ion-icon :icon="arrowBackOutline" />
          </ion-buttons>
          <ion-title>Search</ion-title>
        </ion-toolbar>
      </ion-header> -->
      <ion-searchbar ref="searchRef" mode="ios" class="search-bar" animated="true" placeholder="Search for a team" @ionInput="searchTeam($event)" autofocus />
    <ion-content class="menu-content" ref="contentRef">
      <ion-item class="pl-10">
        <ion-label>Season</ion-label>
        <ion-select placeholder="Select One" v-model="filterSeason" @ionChange="filterSeasonChange">
          <ion-select-option v-for="season in seasons" :key="season._id" :value="season._id">{{ season._id }}</ion-select-option>
        </ion-select>
      </ion-item>
      <div v-if="moreFilters">
        <ion-item class="pl-10">
          <ion-label>Organisation Level</ion-label>
          <ion-select placeholder="Select One" v-model="filterEntityLevel" @ionChange="getCompetitions">
            <ion-select-option value="" v-if="canEntityAccessNational">All Levels</ion-select-option>
            <ion-select-option value="state" v-if="canEntityAccessState">State</ion-select-option>
            <ion-select-option value="association" v-if="canEntityAccessAssociation">Association</ion-select-option>
            <ion-select-option value="club" v-if="canEntityAccessClub">Club</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item class="pl-10">
          <ion-label>Organisation</ion-label>
          <ion-select placeholder="Select One" v-model="filterEntity" @ionChange="fetchTeams('')">
            <ion-select-option v-for="entity in filteredEntitiesByLevel" :key="entity._id" :value="entity._id">{{ entity.name }}</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item class="pl-10">
          <ion-label>Team Status</ion-label>
          <ion-select placeholder="Select Status" v-model="filterTeamStatus" @ionChange="onStatusFilterChange" clearable>
            <ion-select-option value="active">Active</ion-select-option>
            <ion-select-option value="inactive">Inactive</ion-select-option>
          </ion-select>
        </ion-item>
        <ion-item class="pl-10" v-if="competitions.length">
          <ion-label>Competition</ion-label>
          <ion-select
            placeholder="All Competitions"
            v-model="filterCompetitionIds"
            :multiple="true"
            ok-text="Select"
            cancel-text="Clear"
            @ionCancel="clearCompetitionFilter"
            @ionChange="onCompetitionFilterChange"
          >
            <ion-select-option v-for="comp in competitions" :key="comp._id" :value="comp._id">{{ comp.name }}</ion-select-option>
          </ion-select>
        </ion-item>
      </div>
      <div>
        <ion-button class="pl-10 more-filters" v-if="!moreFilters" @click="moreFilters = true">
          More Filters
        </ion-button>
        <ion-button class="pl-10 more-filters" v-if="moreFilters" @click="moreFilters = false">
          Less Filters
        </ion-button>
      </div>
      <!-- <ion-item class="pl-10">
        <ion-label>Filter By</ion-label>
        <ion-select placeholder="Select One" v-model="filterTeams" @ionChange="filterTeamsChange">
          <ion-select-option v-for="filTeam in filterTeamsList" :key="filTeam.value" :value="filTeam.value">{{ filTeam.name }}</ion-select-option>
        </ion-select>
      </ion-item> -->
      <div class="team-list" :key="key" v-if="filterTeams === ''">
        <div class="team-option" v-for="team in filteredTeams" :key="team._id" @click="menuNavigation(`/teams/${team._id}`)">
          <TeamLogo :team="team" />
          <ion-label class="notranslate">{{ team.name }}</ion-label>
        </div>

        <!-- Add pagination controls -->
        <div class="pagination-controls">
          <ion-button :disabled="currentPage === 1" @click="changePage(currentPage - 1)">
            Previous
          </ion-button>
          <span class="page-info">Page {{ currentPage }} of {{ totalPages }}</span>
          <ion-button :disabled="currentPage === totalPages" @click="changePage(currentPage + 1)">
            Next
          </ion-button>
        </div>
      </div>
      <div class="competition-list" :key="key" v-if="filterTeams === 'competitions'">
        <div class="accordion-list">
          <div class="accordion" v-for="comp in filteredCompetitions" :key="comp._id">
            <div class="accordion-header" @click="toggleAccordion(comp)">
              <span class="notranslate">
                {{ get(comp, 'name', '') }}
              </span>
              <div>
                <span v-if="get(comp, 'accordionOpen', false)">▲</span>
                <span v-else>▼</span>
              </div>
            </div>
            <transition name="slide">
              <div class="accordion-content" v-if="get(comp, 'accordionOpen', false)">
                <!-- Your content goes here -->
                <!-- <p>Accordion Content</p> -->
                <div class="team-list-competition">
                  <div class="team-option" v-for="team in get(comp, 'teams', [])" :key="team._id" @click="menuNavigation(`/teams/${team._id}`)">
                    <TeamLogo :team="team" />
                    <ion-label class="notranslate">{{ team.name }}</ion-label>
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </ion-content>
  </ion-page>
</template>

<script>
import {
  flagOutline,
  podiumOutline,
  arrowBackOutline,
  arrowForwardOutline,
  caretDownOutline,
  menuSharp,
  closeOutline
} from "ionicons/icons";
import { loadingController, menuController } from "@ionic/vue";
import TeamLogo from '../matches/base/team-logo.vue'
import _ from 'lodash';
// import moment from 'moment';
export default {
  components: {
    TeamLogo
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      closeOutline,
      menuSharp
    }
  },
  data() {
    // const { filter } = this.$store.state.matches;
    return {
      get: _.get,
      teams: [],
      key: 1,
      filterSeason: 'All Seasons',
      filterTeams: '',
      filterTeamsList: [
        { name: 'All', value: '' },
        { name: 'Competitions', value: 'competitions' },
      ],
      competitions: [],
      search: '',
      currentPage: 1,
      itemsPerPage: 100,
      totalPages: 1,
      totalCount: 0,
      entities: [],
      moreFilters: false,
      filterEntityLevel: '',
      filterEntity: null,
      filterTeamStatus: null,
      filterCompetitionIds: [],
    };
  },
  created() {
    const that = this;
    this.searchTeam = _.debounce(async function(e) {
      const search = e.target.value;
      that.search = search;
      that.currentPage = 1; // Reset to first page on new search
      await that.fetchTeams(search);
      that.key++;
    }, 700);
  },
  async mounted() {
    this.fetchEntities();
    this.getCompetitions();
    try {
      this.$store.dispatch('national/setup');
      await this.fetchTeams();
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
    setTimeout(() => this.$refs.searchRef.$el.setFocus(), 500);
    if (this.canEntityAccessNational) {
      this.filterEntityLevel = '';
    } else if (this.canEntityAccessState) {
      this.filterEntityLevel = 'state';
    } else if (this.canEntityAccessAssociation) {
      this.filterEntityLevel = 'association';
    } else if (this.canEntityAccessClub) {
      this.filterEntityLevel = 'club';
    }
  },
  computed: {
    seasons(){
      const seasons =  this.$store.state.national.seasons;
      return seasons.sort((a, b) => b._id - a._id).concat({ _id: 'All Seasons' });
    },
    entity(){
      return this.$store.getters['national/getEntity'];
    },
    canEntityAccessClub(){
      const entity = this.$store.getters['national/getEntity'];
      if(!entity || !entity.level) return true;
      return ['club', 'association', 'state', 'national'].includes(entity.level);
    },
    canEntityAccessAssociation(){
      const entity = this.$store.getters['national/getEntity'];
      if(!entity || !entity.level) return true;
      return ['association', 'state', 'national'].includes(entity.level);
    },
    canEntityAccessState(){
      const entity = this.$store.getters['national/getEntity'];
      if(!entity || !entity.level) return true;
      return ['state', 'national'].includes(entity.level);
    },
    canEntityAccessNational(){
      const entity = this.$store.getters['national/getEntity'];
      if(!entity || !entity.level) return true;
      return ['national'].includes(entity.level);
    },
    filteredTeams() {
      // Season, competition and status are all filtered server-side so the
      // pagination totals match what's actually shown. Filtering season here
      // narrowed only the current page, and did it on the team document's own
      // `season` field rather than the season of the competition the team plays
      // in — which is why a season showed a fraction of the teams Admin lists.
      return this.teams;
    },
    filteredCompetitions() {
      const { competitions } = this;
      const mapComp = _.map(competitions, (c) => {
        return {
          _id: c._id,
          teamNames: _.map(c.teams, 'name'),
        }
      });
      // Filter competitions based on the search
      if (this.search) {
        const searchedComps = _.filter(competitions, (comp) => {
          const teamNames = _.map(comp.teams, 'name');
          return _.filter(teamNames, (teamName) => {
            return _.includes(teamName.toLowerCase(), this.search.toLowerCase());
          }).length > 0;
        });
        console.log({
          searchedComps
        });
        return searchedComps;
      }
      console.log({
        mapComp
      });
      return _.orderBy(competitions, ['order'], ['asc']);
    },
    // groupTeamsByCompetition() {
    //   const { filteredTeams } = this;
    //   return _.groupBy(filteredTeams, 'competition');
    // }
    filteredEntitiesByLevel() {
      const { entities, filterEntityLevel } = this;
      const entity = this.$store.getters['national/getEntity'];
      // console.log({
      //   entities,
      //   filterEntityLevel,
      //   entity: this.$store.getters['national/getEntity']
      // });
      if (entity && entity.level) {
        // console.log('Filtering based on current entity level');
        // entities.forEach(ent => {
        //   if (ent._id === entity._id || _.get(ent, `orgtree.${entity.level}._id`, null) === entity._id) {
        //     console.log({
        //       entId: ent._id,
        //       entOrgTree: ent[`orgtree.${entity.level}._id`],
        //       entityId: entity._id,
        //       entityLevel: entity.level,
        //       entOrg: _.get(ent, `orgtree.${entity.level}._id`, null),
        //       entType: ent.type,
        //       entName: ent.name
        //     });
        //   }
        // });
        return entities.filter(ent => ent._id === entity._id || _.get(ent, `orgtree.${entity.level}._id`, null) === entity._id);
      }
      if (!filterEntityLevel) return entities;
      return entities.filter(entity => entity.type === filterEntityLevel);
    }
  },
  methods: {
    filterSeasonChange() {
      // Season is a server-side filter now, so the team list has to be refetched
      // rather than just narrowed in place.
      this.currentPage = 1;
      this.getCompetitions();
      this.fetchTeams(this.search);
    },
    onStatusFilterChange() {
      this.currentPage = 1;
      this.fetchTeams(this.search);
    },
    onCompetitionFilterChange() {
      // Reset to page 1 — the previous page number may not exist in the
      // narrower filtered result set.
      this.currentPage = 1;
      this.fetchTeams(this.search);
    },
    clearCompetitionFilter() {
      this.filterCompetitionIds = [];
      this.onCompetitionFilterChange();
    },
    filterTeamsChange() {
      this.getCompetitions();
    },
    async getCompetitions() {
      const params = {};
      if (this.filterSeason !== 'All Seasons') params.season = this.filterSeason;
      const resComps = await this.$http.get("/assemble/api/v1/live/competitions", {
        params
      });
      this.competitions = _.get(resComps, 'data.data', []);
      for (const comp of this.competitions) {
        comp.accordionOpen = false;
      }
      // Drop any selections that aren't valid for the newly loaded season.
      const availableIds = _.map(this.competitions, '_id');
      const stillValid = _.intersection(this.filterCompetitionIds, availableIds);
      if (stillValid.length !== this.filterCompetitionIds.length) {
        this.filterCompetitionIds = stillValid;
        this.currentPage = 1;
        this.fetchTeams(this.search);
      }
    },
    menuNavigation(url){
      menuController.close("side");
      if(this.entity && this.entity.level && this.entity.name){
        url = `/c/${this.entity.level}/${this.entity.name}${url}`
      }
      this.$router.push(url);
    },
    goPrev() {
      this.$router.go(-1);
    },
    toggleAccordion(comp) {
      comp.accordionOpen = !comp.accordionOpen;
    },
    async changePage(page) {
      this.currentPage = page;
      await this.fetchTeams();
      // Get the IonContent element and scroll to top
      const content = this.$refs.contentRef.$el;
      if (content) {
        await content.scrollToTop(300);
      }
    },
    async fetchTeams(search = '') {
      try {
        loadingController
          .create({ message: "Loading Teams..." })
          .then(async loading => {
            loading.present();
            const params = {
              page: this.currentPage,
              limit: this.itemsPerPage,
            };

            if (search && search !== '') {
              params.search = search;
            }

            if (this.entity && this.entity._id) {
              params.entityType = this.entity.level;
              params.entityId = this.entity._id;
            }

            if (this.filterEntity) {
              params.entityId = this.filterEntity;
              const entity = _.find(this.filteredEntitiesByLevel, { _id: params.entityId });
              params.entityType = entity?.type;
            }

            if (this.filterTeamStatus) {
              params.status = this.filterTeamStatus;
            }

            if (this.filterSeason && this.filterSeason !== 'All Seasons') {
              params.season = this.filterSeason;
            }

            if (this.filterCompetitionIds && this.filterCompetitionIds.length) {
              params.competitionIds = this.filterCompetitionIds.join(',');
            }

            const resTeam = await this.$http.get("/assemble/api/v1/live/teams", { params });
            this.teams = resTeam.data.data;
            this.totalPages = resTeam.data.pagination.totalPages;
            this.totalCount = resTeam.data.pagination.totalCount;
            loading.dismiss();
          });
      } catch (error) {
        console.error(error);
      }
    },
    async fetchEntities() {
      try {
        const resEntities = await this.$http.get("/assemble/api/v1/live/entities");
        this.entities = resEntities.data.data;
      } catch (error) {
        console.error(error);
      }
    },
  }
};
</script>
<style scoped lang="scss">

ion-title {
  font-family: 'Cairo';
}

ion-grid {
  white-space: nowrap;
   --offset-bottom: auto!important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

.header-bar {
  padding: 0.5rem;
}

.search-bar {
  color: #fff;
}

.round-text {
  color: #fff;
  font-family: 'Cairo';
  text-align: center;
  font-size: 14px;
  text-transform: uppercase;
  // text-decoration: underline;
  // text-decoration-color: $highlight;
}

.team-list {
  margin-top: 2rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

ion-label {
  color: white;
  font-family: 'Cairo';
  font-size: 0.8rem;
}


ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
.light-text {
  font-size: 14px;
  font-weight: 400;
  text-transform: capitalize;
}
.normal-text {
  font-size: 15px;
  font-weight: 600;
  text-transform: capitalize;
}
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: 'BrownStd-Regular';
  color: white;
  background: transparent;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: 'BrownStd-Regular';
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
   box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: 'BrownStd-Regular';
  text-align: center;
  font-size: .9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios, .list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment ion-label {
  margin-bottom: 0;
}

// ion-content {
//   background: $background;
//   --background: $background;
//   --offset-bottom: auto!important;
//   --overflow: hidden;
//   overflow: auto;
// }

ion-content {
  background: $background;
  --background: $background;
}

ion-content::part(scroll)::-webkit-scrollbar {
  width: 0.35rem;
}

ion-content::part(scroll)::-webkit-scrollbar-track {
  background-color: rgba(0, 0, 0, 0.3);
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

ion-content::part(scroll)::-webkit-scrollbar-thumb {
  background-color: #888;
}

@media only screen and (max-width: 768px) {
  ion-content::part(scroll)::-webkit-scrollbar {
    width: 0.15rem;
  }
}

// ion-content::-webkit-scrollbar-track
// {
//   -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
//   background-color: rgba(0,0,0,0.3);
// }

// ion-content::-webkit-scrollbar
// {
//   width: .35rem;
//   background-color: rgba(0,0,0,0.3);
// }

// @media only screen and (max-width: 768px) {
//   ion-content::-webkit-scrollbar {
//     width: .15rem;
//     background-color: rgba(0,0,0,0.3);
//   }
// }

// ion-content::-webkit-scrollbar-thumb
// {
//   background-color: #888;
// }


.overlay {
  background: $background;
  // background: $primary;
  padding: 0rem;
}

ion-toolbar, ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
   display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width:70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button{
  flex-basis: 50%;
}


.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, .2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, .7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.competition-list {
  display: flex;
  justify-content: center;
  width: 100%;
  margin-top: 2rem;
}

.accordion-list {
  width: 80rem;
  // width: 100%;
  margin: 0 1.5rem;
}

.accordion {
  margin-bottom: 10px;
  min-width: 12rem;
  border-radius: 10px;
  overflow: hidden;
  background-color: #17181B ;
  color: white;
}

.accordion-header {
  cursor: pointer;
  padding: 15px;
  display: flex;
  justify-content: space-between;
  background-color: #222;
}

.accordion-content {
  padding: 15px;
}

.team-list-competition {
  margin-top: 1rem;
  margin-bottom: 1rem;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(130px, 1fr));
  padding: 0 1.5rem;
  gap: 1.5rem;
  .team-option {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
}

.rotate-arrow {
  transform: rotate(180deg);
  transition: transform 0.2s ease-in-out;
}

.slide-enter-active, .slide-leave-active {
  transition: all 0.2s ease;
}

.slide-enter, .slide-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

.pagination-controls {
  grid-column: 1 / -1;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  margin-top: 2rem;

  .page-info {
    color: white;
    font-family: 'Cairo';
  }
}

.more-filters {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>

<style lang="scss">
/*
  Unscoped on purpose: ion-select's alert renders in an overlay portal outside
  this component, so a scoped rule can never reach it. The comment lives inside
  the block because a top-level HTML comment between two <style> blocks makes
  the production build drop the block that follows it.

  Targets Ionic's own multiple-select-alert class rather than a cssClass passed
  through interfaceOptions, which did not survive to the overlay. The Competition
  filter is the only multi-select in this app, so the rule can't reach anything else.
*/
ion-alert.multiple-select-alert {
  --width: min(90vw, 28rem);

  .alert-wrapper {
    width: min(90vw, 28rem);
    max-width: min(90vw, 28rem);
  }

  .alert-checkbox-label {
    white-space: normal;
  }
}
</style>